export default __webpack_public_path__ + "static/media/9.d82b2e05.webp";